import permisos, { RESOURCE_CONVENIOS } from '@/auth/permissions/modules/convenios'
import {
    ROUTE_TRANSACCIONES_APROBACION_CONVENIO,
    ROUTE_TRANSACCIONES_CONVENIO,
    ROUTE_TRANSACCIONES_GESTION_CONVENIO,
} from '@/router/routes/convenios/names'
import { defineMenu } from '@/utils/menu'

const { transacciones } = permisos

export default defineMenu([
    {
        title: 'convenios.menu_title',
        resource: RESOURCE_CONVENIOS,
        action: transacciones.convenios._perm,
        children: [
            {
                title: 'convenios.subopciones.gestion_convenio',
                action: transacciones.convenios.gestionConvenios,
                resource: RESOURCE_CONVENIOS,
                route: ROUTE_TRANSACCIONES_GESTION_CONVENIO,
            },
            {
                title: 'convenios.subopciones.convenio',
                action: transacciones.convenios.creacionConvenio,
                resource: RESOURCE_CONVENIOS,
                route: ROUTE_TRANSACCIONES_CONVENIO,
            },
            {
                title: 'convenios.subopciones.aprobacion_convenio',
                action: transacciones.convenios.aprobacionConvenio,
                resource: RESOURCE_CONVENIOS,
                route: ROUTE_TRANSACCIONES_APROBACION_CONVENIO,
            },
        ],
    },
])
